import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { build, pool } from 'src/app/common/classes/request-builder';
import { BaseForm } from 'src/app/view/base-form';
import { ProductosApiService } from 'src/app/service/api/productos-api';
import { DashboardService } from 'src/app/service/events/dashboard.service';
import { VentasApiService } from 'src/app/service/api/ventas-api.service';
import { ProductosFertilizantesFormDefinition } from './form-control/form-definition';
import {
    ReactiveFormChangedField,
    ReactiveFormStableValueChange,
    ReactiveFormValue,
} from '@fitogest/reactive-form-builder/interfaces';

import type { ProductosModel } from 'src/app/models/productos/productos.model';
import type { Compradores } from 'src/app/models/ventas/compradores.model';

@Component({
    selector: 'app-producto-fertilizante-form',
    standalone: false,
    templateUrl: './producto-fertilizante-form.component.html',
    styleUrls: ['./producto-fertilizante-form.component.scss'],
})
export class ProductoFertilizanteFormComponent extends BaseForm<ProductosModel> implements OnInit {
    public override model: ProductosModel = { nombre: '', materia_activa: '', tipo: 'fertilizante' };

    public form!: ProductosFertilizantesFormDefinition;

    public formReady = false;

    public loadingData = true;


    public constructor(
        public override route: ActivatedRoute,
        public dashboardEvents: DashboardService,
        public productApi: ProductosApiService,
        private readonly ventasApi: VentasApiService,
        public override router: Router,
    ) {
        super(
            route,
            router,
            dashboardEvents,
            productApi.productos.PUT,
            productApi.productos.POST,
            'productos-fertilizantes',
            'Actualizar Fertilizante',
            'Crear Fertilizante',
        );
    }// constructor();

    public async ngOnInit(): Promise<void> {
        this.model = this.buildInitialModel(this.getModel());
        this.form = new ProductosFertilizantesFormDefinition(
            this.getType(),
            this.model,
            null,
        );

        await this.initFormData();
        this.softInit(this.getType());
        this.formReady = true;
    }// ngOnInit();

    public formChanges(
        formModel: ReactiveFormValue<ProductosModel>,
        lastChangedFieldName: ReactiveFormChangedField<ProductosModel>,
    ): void {
        this.updateFormModel(formModel, lastChangedFieldName);
    }// formChanges();

    public stableValueChanges(event: ReactiveFormStableValueChange<ProductosModel>): void {
        this.updateFormModel(event.value, event.changedField);
    }// stableValueChanges();


    public override goBack(): void {
        this.router.navigate(['dashboard', this.pathToGoBack]);
    }// goBack();

    private initFormData(): Promise<boolean> {
        this.loadingData = true;
        this.resetExternalDropdowns();

        return pool([
            build(
                this.ventasApi.compradoresGET,
                this.form.lists.empresa,
                (it: Compradores) => it.tipo === 'Proveedor' ? it.razon_social : '',
            ),
        ]).then(() => {
            this.loadingData = false;
            this.finalizeExternalDropdowns();

            return true;
        }).catch((error: unknown) => {
            this.loadingData = false;
            this.finalizeExternalDropdowns();
            console.error('Error loading fertilizer product form data.', error);

            return true;
        });
    }// initFormData();

    private updateFormModel(
        formModel: ReactiveFormValue<ProductosModel>,
        lastChangedFieldName: ReactiveFormChangedField<ProductosModel>,
    ): void {
        this.form.updateModel(formModel, lastChangedFieldName);
        this.model = this.form.model as ProductosModel;
    }// updateFormModel();

    private buildInitialModel(routeModel: ProductosModel): ProductosModel {
        return {
            ...routeModel,
            tipo: 'fertilizante',
        } as ProductosModel;
    }// buildInitialModel();

}// class;
